import { Input } from 'semantic-ui-react';
import { toNumber } from '../utils/calculations';

const DisplayField = (props: any) => {
	const handleChange = (e: any, data: any) => {
		let value = data.value.replace(/[^0-9]/g, '');

		let values = {
			formatted: value,
			raw: toNumber(value),
		};

		data.value = values;
		return props.onChange(e, data);
	};

	return (
		<Input
			{...props}
			fluid
			onChange={handleChange}
			placeholder={'0'}
			value={props.value}
		/>
	);
};

export default DisplayField;
